import { listItOperationPackages as listOperationPackagesFromFeature } from "@/features/operation-package/api/it-operation-packages";
import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

// 新しい場所に移行済み - 後方互換性のため残しておく
export const listOperationPackages = listOperationPackagesFromFeature;

export async function listPackagePatterns(packageId: string) {
  const res = await apiClient.GET(
    `/v2/it-operation-core/operation-packages/{id}/patterns`,
    { params: { path: { id: packageId } } },
  );

  return getDataOrThrowApiError(res);
}

export async function createPattern(packageId: string) {
  const res = await apiClient.POST(
    `/v2/it-operation-core/operation-packages/{id}/patterns`,
    {
      params: { path: { id: packageId } },
      body: {},
    },
  );

  return getDataOrThrowApiError(res);
}

export async function createPatternManual(
  packageId: string,
  body: { name: string; description?: string },
) {
  const res = await apiClient.POST(
    `/v2/it-operation-core/operation-packages/{id}/patterns`,
    {
      params: { path: { id: packageId } },
      body,
    },
  );

  return getDataOrThrowApiError(res);
}
